import toast from "react-hot-toast";
import * as api from "../Api/index.js";

export const signin = (formData, navigate) => async (dispatch) => {
  let loggingId;
  try {
    loggingId = toast.loading("We are logging you in...");
    const { data } = await api.signIn(formData);
    toast.remove(loggingId);
    // Password right, authenticator code still to come: the page asks for it
    if (data.twoFactor) return data;
    dispatch(signedIn(data, navigate));
  } catch (error) {
    toast.remove(loggingId);
    const dataError = error.response?.data?.message;
    const dataError2 = error.response?.data;
    toast.error(dataError || dataError2 || "Could not reach the server");
  }
};

// Another CBX app sends its users here (?next=its address) to give their
// authenticator code; they go back there once signed in. Only our own apps.
const returnAddress = () => {
  const next = new URLSearchParams(window.location.search).get("next");
  if (!next) return null;
  try {
    const url = new URL(next);
    const ours =
      (url.protocol === "https:" && url.hostname.endsWith(".cbxapps.com")) ||
      ["localhost", "127.0.0.1"].includes(url.hostname);
    return ours ? url.href : null;
  } catch {
    return null;
  }
};

// The login answer, from the password or from the authenticator-code step
export const signedIn = (data, navigate) => (dispatch) => {
  dispatch({ type: "AUTH", data });
  toast.success("Signed in");
  const next = returnAddress();
  if (next) window.location.assign(next);
  else navigate("/");
};

//  forgot password
export const forgetPassword = (postData) => async (dispatch) => {
  try {
    const { data } = await api.forgotPassword(postData);
    dispatch({ type: "FORGET_PASSWORD", payload: data });
    const emailSentMessage =
      "Please check your email, we have sent you reset link";
    dispatch({ type: "EMAIL_SENT_TO_USER", emailSentMessage });
  } catch (error) {
    const emailSendingError = error.response.data.message;
    dispatch({ type: "EMAIL_SENDING_ERROR", emailSendingError });
  }
};
//  forgot password
export const resetPassword = (token, postData) => async (dispatch) => {
  try {
    const { data } = await api.resetPassword(token, postData);
    dispatch({ type: "RESET_USER_PASSWORD", payload: data });
    const message = "password successfully changed";
    dispatch({ type: "RESET_USER_PASSWORD_SUCCESS", message });
  } catch (error) {
    const resetError = error.response.data.message;
    dispatch({ type: "RESET_USER_PASSWORD_ERROR", resetError });
  }
};
// update user
export const updateUser = (id, postData) => async (dispatch) => {
  try {
    const { data } = await api.updateUser(id, postData);
    dispatch({ type: "UPDATE_SELECTED_USER", payload: data });
  } catch (error) {}
};

// change password
export const changePassword = (postData) => async (dispatch) => {
  try {
    const { data } = await api.changePassword(postData);
    dispatch({ type: "CHANGE_MY_PASSWORD", payload: data });
    const changeMessage = "password successfully changed";
    dispatch({ type: "CHANGE_USER_PASSWORD_SUCCESS", changeMessage });
  } catch (error) {
    const changeError = error.response.data.message;
    dispatch({ type: "CHANGE_USER_PASSWORD_ERROR", changeError });
  }
};
